import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";
import DesignDivers from "../../Common/DesignDivers";
import ButtonsDivers from "../../Common/ButtonsDivers";
import IconesDivers from "../../Common/IconesDivers";
import { useSelector } from "react-redux";

export function AppDivers() {
    const { t } = useTranslation();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);

    const tabs = [
        {
            title: t("Divers"),
            content: (
                <div className="banner-container">
                    <section className="text-section">
                        <DesignDivers
                            path={["template", "Application", "Divers"]}
                            icone={true}
                            titleImage="Order button"
                            titleColorActivate={false}
                        />
                        <ButtonsDivers />
                        <IconesDivers />
                    </section>
                </div>
            ),
            customClassName: "",
        },
    ];

    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    return (
        <React.Fragment>
            <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                <Nav
                    tabs
                    style={{
                        backgroundColor: "white",
                        width: "50px",
                        display: "grid",
                        gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                        border: "unset",
                    }}
                >
                    {tabs.map((element, index) => (
                        <NavItem
                            key={index}
                            className={classNames(
                                "pb-1",
                                "d-flex align-items-center text-nowrap",
                                {
                                    "disable-nav-item__clz":
                                        activeTab !== index,
                                },
                                element.customClassName
                            )}
                            style={{
                                cursor: "pointer",
                                borderBottom:
                                    activeTab === index
                                        ? `${mainColor} 3px solid`
                                        : "",
                            }}
                        >
                            <NavLink
                                className={classNames("text-dark w-100", {
                                    "active customer-account-menu-nav-link-active__clz":
                                        activeTab === index,
                                    "customer-account-menu-nav-link-disable__clz":
                                        activeTab !== index,
                                })}
                                onClick={() => toggleNav(index)}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                }}
                            >
                                <span
                                    className="px-2"
                                    style={{
                                        font:
                                            "normal normal 600 20px/27px Segoe UI",
                                        marginRight: "20px",
                                    }}
                                >
                                    {element.title}
                                </span>
                            </NavLink>
                        </NavItem>
                    ))}
                </Nav>
            </div>
            <TabContent activeTab={activeTab} className="h-100">
                {tabs.map((element, index) => (
                    <TabPane
                        tabId={index}
                        key={index}
                        style={{ height: "100%" }}
                    >
                        {element.content}
                    </TabPane>
                ))}
            </TabContent>
        </React.Fragment>
    );
}
